import type { MissingInput, PlanItem, RefinementResult } from "../../types";
import { describeRefinementChange } from "./refinementCopy";

/**
 * W4-03 — the per-answer change summary. Kept as a component-only file
 * (react-refresh/only-export-components): the pure copy-generation logic
 * it shares with the live-region announcement lives in `refinementCopy.ts`.
 * See docs/design/features/W4-03.md "Change summary".
 */
export function RefinementChangeSummary({
  result,
  items,
  queue,
}: {
  result: RefinementResult | null;
  items: PlanItem[];
  queue: MissingInput[];
}) {
  const { heading, lines } = describeRefinementChange(result, items, queue);
  return (
    <aside className="confirmation" aria-labelledby="refinement-change-heading">
      <p className="eyebrow">Saved</p>
      <h2 id="refinement-change-heading">{heading}</h2>
      {lines.map((line) => (
        <p key={line}>{line}</p>
      ))}
    </aside>
  );
}
